import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { push } from 'connected-react-router';

interface ModalFooterCTAProps {
  title: string;
  type: string;
  onClick: () => void;
  valueFromReduxState?: string;
  push?: (path: any) => void;
}

class ModalFooterCTA extends Component<ModalFooterCTAProps> {
  props: any;

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <React.Fragment>
        <Button
          data-button-title
          type={this.props.type}
          title={this.props.title}
          onClick={this.props.onClick}
          fitContainerWidth={mq.matches ? true : false}
        />
      </React.Fragment>
    );
  }
}

export default connect(null, { push })(ModalFooterCTA);
